export default "__VITE_ASSET__ebQdTeq7__"